<template>
  <div class="home" id="home1">
    <div class="fixedHeroVideo">
        <!-- {{meta_data.page_title}}{{meta_data.meta_description}} -->
        <home-hero v-if="minisite_ready" 
          :meta_title="meta_data.page_title" 
          :meta_desc="meta_data.meta_description">        
        </home-hero>
    </div>

    <!--
    <div class="mmsx" style="height:150vh;color:red;font-size:10px;padding:100px">
        minisite_data:<br/>
        {{minisite_data}}
        <br/><br/>
        minisite_dic:<br/>
        {{minisite_dictionary}}
    </div>
    -->    
    
    <main v-if="minisite_ready">
      <section class="siteSection transparentSection">
        &nbsp; <!--empty transparent section for the video bg-->
      </section>
      
      <section class="siteSection heroText secBgGray1">
        <!-- must have clear element here -->
        <!-- <home-hero-text :sectionDataIndex="0"></home-hero-text> -->
      </section>      
      <section class="siteSection scrollSection secBgGray2">
        <home-benefits :sectionDataIndex="1"></home-benefits>
      </section>
      <section class="siteSection scrollSection secBgWhite">
        <implant-range  :sectionDataIndex="2"></implant-range>
      </section>
      <section class="siteSection scrollSection secBgGray2">
        <tech-info  :sectionDataIndex="3"></tech-info>
      </section>
      <section class="siteSection scrollSection secBgWhite">
        <drilling-protocols :sectionDataIndex="4"></drilling-protocols>
      </section>
      <section class="siteSection scrollSection">
        <coverscrews :sectionDataIndex="5"></coverscrews>
      </section>
      <section class="siteSection scrollSection kit">
        <lance-kit :sectionDataIndex="6"></lance-kit>
      </section>
      <!--
      <section class="siteSection scrollSection secBgGray1">
        <insertion-options :sectionDataIndex="7"></insertion-options>
      </section>
      -->
      <section class="siteSection scrollSection">
        <packaging :sectionDataIndex="8"></packaging>
      </section>
      <section class="siteSection scrollSection secBgWhite">
        <prosthetic :sectionDataIndex="9"></prosthetic>
      </section>
      <section class="siteSection scrollSection secBgWhite">
        <videos-gallery :sectionDataIndex="10"></videos-gallery>
      </section>

      <!-- ARTICLES SECTION -->
      <section class="siteSection scrollSection secBgGray2 proArticlesSection">
          <div class="articlesGrid"><!-- articlesCol linksCol -->
            <div class="arCol1"> 
              <product-cases
                :itemsTitle="panels_data.children[3].title" 
                :itemsData="panels_data.children[3].children">
              </product-cases>
              <product-cases 
                :itemsTitle="panels_data.children[4].title" 
                :itemsData="panels_data.children[4].children">
              </product-cases>
            </div>

            <div class="arCol2" style="color:#000;">

              <!-- catalog btn data -->              
              <abtn v-if="catalog_btn_data" style="float:left;" color="blue" :href="catalog_btn_data.url" :class="['self-end mt-xl']" mini>
                <span style="font-weight:400 !important;">{{catalog_btn_data.title}}</span>
              </abtn>

              <!-- links list -->
              <div class="product-info-links" v-if="links_data">                  
                  <div class="text-blue-4">{{links_data.title}}:</div>
                  <a v-for="linkItem in links_data.children" :href="linkItem.url" target="_blank" :key="linkItem.id">
                    <i class="fal fa-file-pdf"></i><span>{{linkItem.title}}</span>
                  </a>
              </div>  

            </div>
          </div>
      </section>
      <!-- ARTICLES SECTION -->
    

    </main>
  </div>
</template>

<style>
  *
  {
    margin-block-start: 0px;
    margin-block-end: 0px;    
  }
  footer
  {
    position: relative !important;
  }

  .product-info-links
  {
    padding-top: 20px;    
    margin-bottom: 20px;
    clear: both;
    display: block;
  }
  .product-info-links a,
  .product-info-links a:visited
  {
      padding-top: 10px;
      display: block;
      width: 100%;
      color:#2d2d2d;
  }
  .product-info-links a:hover
  {
      color:#3faef5 !important;
  }
  .product-info-links a span
  {
    padding-left: 8px;
  }
  .articlesGrid
  {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    align-items: stretch;
    justify-content: space-between;    
  }
  .arCol1
  {
    width: 70%;
    color:#202020;
    padding-right: 2vw;
  }
  .arCol2
  {
    padding-left: 2vw;
    width: 30%;
    color:#202020;
    word-wrap: break-word;
  }


  :root {
      --graybg1: #eee;
      --text-blue: #40738d;
      --dark-blue: #030f1a;
      --text-gray-dark: #3f3f3f;
  }
    body::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }
    .hiddenfonttext
    {
      position: fixed;top:-100px;left:0px;font-size: 9px;
    }

    /* minisite fonts */
    .msSecTitle
    {
        font-size: clamp(24px,2.5vw,40px);letter-spacing: -1px;   
    }
    .msSubTitle
    {
        font-size: clamp(16px,1.2vw,30px);letter-spacing: -1px; 
    }

    .msFont1
    {
        font-size:clamp(0.75rem, 0.8vw, 1.5rem) !important;
    }
    .msFont15
    {
        font-size:clamp(16px, 1.1vw, 30px) !important;
    }
    .msFont2
    {
        font-size:clamp(1.2rem, 1.4vw, 2.5rem) !important;
    }
    .msBold
    {
      font-weight:500 !important;
    }


    .topBar
    {
      position: fixed;
      z-index:100;
      top:0px;left:0px;
      width: 100vw;
      height: 70px;
      display: grid;
      align-items: center;     
      background-color:#1178be; 
    }
    .topBar .topLogo{
      width: 200px;height: auto;    
      padding-left: 30px;
    }
    .topBar .menuOpen
    {
        width:30px;height:24px;
        position: absolute;right: 40px; 
        opacity:0.7;cursor:pointer !important;    
    }
    .topBar .menuOpen span
    {
        width: 100%;height:2px;
        background-color: #fff;position: absolute;top:0px;cursor:pointer;
        pointer-events: none;
    }
    .topBar .menuOpen span:nth-child(1){top:0px;}
    .topBar .menuOpen span:nth-child(2){top:10px;}
    .topBar .menuOpen span:nth-child(3){top:20px;}

    .topBar .menuLang
    {
        width:60px;height:24px;
        position: absolute;
        right: 70px; 
        opacity:0.7;cursor:pointer !important;  
        color: #fff;  
        font-weight: bold;
    }
    .topBar .menuLang i
    {
      font-size: 12px;padding-left: 8px;opacity: 0.6;
    }

    .fixedProNav
    {
      position: fixed;
      height: 100px;
      width: 100%;
      background-color: #f9f9f9;
      top: 121px;
      left: 0px;
      z-index: 10000;
      display: flex;
      align-content: center;
      align-items: center;
    }
    .fixedProNav .logo
    {
        height: 24px;
        width: auto;
    }
    .fixedHeroVideo
    {
      position: fixed;            
    }

    main {
      perspective: 2px;
      overflow-x: hidden;
      overflow-y: auto;  
    }

  .siteSection {
    transform-style: preserve-3d;
    position: relative;
    height: 100vh;width: 100%;
  }
  .siteSection.heroText{
    /* height: 50vh; */
    height: 0px;
    display: none;
  }
  .siteSection.secBgWhite{
    background-color: #fff;
  }
  .siteSection.secBgGray1{
    background-color: #fcfcfc;    
  }
  .siteSection.secBgGray2{
    background-color: var(--graybg1);
  }
  .siteSection.proArticlesSection{
    /* height: 50vh; */
    height:auto !important;
    padding: 100px 10vw;
  }



  .disabledSection
  {
    pointer-events: none !important;
  }

    .sectionTitle
    {
        font-size: 30px;
        font-weight: 200;
        letter-spacing: -1px;        
        text-align:center;        
        position:absolute;
        left: 0px;
        top:100px;width: 100%;        
    }  
    .sectionTitle.white
    {
      color: #fff !important;
    }
    .sectionTitle.black
    {
      color: #000 !important;
    }
    .sectionTitle.blue
    {
      color: var(--text-blue);
    }

    @media (max-width: 850px)
    {
      .topBar
      {
        width: 100vw;
        height: 80px;
        background-color: #1178be;
        opacity: 1;
      }
      .topBar .topLogo{
        width: 184px;
        height: auto;    
        padding-left: 20px;
      }
      .topBar .menuOpen
      {
        right: 25px; 
        top:30px;        
      }      
      .topBar .menuLang
      {
          position: absolute;right: 60px; 
          cursor:pointer !important;
          color: #fff;  
          font-weight: bold;
          height: auto;        
      }
      .siteSection
      {
        /* min-height: calc(100vh + 80px); */
        min-height: 60vh;
        position: static;
        height: auto;
        float: left;
      }
      .siteSection.heroText
      {
        height: auto;
        min-height: 30vh;
      }
      .siteSection.transparentSection
      {
        display: none;
      }

      .___siteSection.footer
      {
        min-height: 400px !important;
        max-height: 100vh !important;
      }
      .siteSection.kit
      {
        min-height: 400px !important;
        max-height: 100vh !important;
      }

      .sectionTitle
      {
        font-size: 22px;
        position: static;
        text-align: center;
        padding-top: 100px;
      }        
      .fixedHeroVideo
      {
        position: initial;      
      }
      .siteSection.kit
      {
        min-height: 30vh;
        max-height: initial;
        height: auto;
      }
    }

    @media (max-width: 850px) and (orientation: portrait)
    {
      .siteSection.heroText{
        height: auto;
        min-height: initial;
      }

    }

</style>

<style scoped>
  .debugbox
  {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100vh;
    background-color: #000;
    color: #fff;
    font-size: 10px;
    padding: 50px;
    overflow-y: scroll;
  }
</style>

<script>
  /* import LangMenu           from "@/views/com/langmenu.vue";
  import SiteMenu           from "@/views/com/menu.vue";
   */
  import HomeHero           from "@/views/product-site/LanceHero.vue";
  import HomeHeroText       from "@/views/product-site/LanceHeroText.vue";
  import HomeBenefits       from "@/views/product-site/LanceBenefits.vue";
  import ImplantRange       from "@/views/product-site/LanceImplantRange.vue";
  import DrillingProtocols  from "@/views/product-site/LanceDrillingProtocols.vue";
  import TechInfo           from "@/views/product-site/LanceTechInfo.vue";
  import InsertionOptions   from "@/views/product-site/LanceInsertionOptions.vue";
  import Packaging          from "@/views/product-site/LancePackaging.vue";  
  import Coverscrews        from "@/views/product-site/LanceCoverscrews.vue";  
  import Prosthetic         from "@/views/product-site/LanceProsthetic.vue";  
  import LanceKit           from "@/views/product-site/LanceKit.vue";  
  import ProductCases           from "@/views/product-site/ProductCases.vue";  
  
  import VideosGallery           from "@/views/product-site/Vimeos.vue";  
  //import VideosGallery           from "@/views/product-site/Videos.vue";  

  /* import AppFooter          from "@/views/product-site/AppFooter.vue";     */

  import { mapActions, mapState } from "vuex";
  
  export default 
  {
    data(){
      return{
        minisite_ready:false,        
        minisite_data:null,
        minisite_dictionary:null,
        isMenuOpen:false,
        isLangOpen:false
      }
    },
    head: {
      title: function() {
        return {inner: this.pageTitle};
      },
      meta: function() {
      return [
        { name: "description", content: this.pageDescription, id: "desc" },
        { name: "keywords", content: this.pageKeywords, id: "key" }
        ];
      }
    },    
    components:
    {
      /* LangMenu,SiteMenu, */
      VideosGallery,
      ProductCases,
      HomeHero,
      HomeHeroText,
      HomeBenefits,
      ImplantRange,
      DrillingProtocols,
      TechInfo,
      InsertionOptions,
      Packaging,
      Coverscrews,
      Prosthetic,
      LanceKit,
      visibleSection:0
    }, 
    computed: {
    ...mapState(["siteData","siteDataReady","siteReady","minisite_VisibleSection","pageLayoutData"]),
    pagedata()
    {
      if (!this.pageLayoutData) return null;
      return this.pageLayoutData;
    },
    children() 
    {
      if (!this.pageLayoutData || !this.pageLayoutData.children) return null;
      return this.pageLayoutData.children;
    },
    meta_data()
    {
        if (!this.pageLayoutData || !this.pageLayoutData.children) return null;
        var mData = this.pageLayoutData.meta;
        return mData;
    },
    panels_data()
    {
        if (!this.pageLayoutData || !this.pageLayoutData.children) return null;
        var panels = this.findNodeByType(this.pageLayoutData.children,"panels");
        return panels;
    },
    links_data()
    {
        if (!this.pageLayoutData || !this.pageLayoutData.children) return null;
        var links = this.findNodeByType(this.pageLayoutData.children,"links-list");
        return links;
    },
    catalog_btn_data()
    {
        if (!this.pageLayoutData || !this.pageLayoutData.children) return null;
        var catalogBtn = this.findNodeByTitle(this.pageLayoutData.children,"View products");
        return catalogBtn;
    },
    clinical_cases()
    {
      if (!this.pageLayoutData || !this.pageLayoutData.children) return null;
      
      //find the clinical cases 
      //type":"publication-list

    },
    pageTitle() {
      return this.pageLayoutData &&
        this.pageLayoutData.meta &&
        this.pageLayoutData.meta.page_title
        ? this.pageLayoutData.meta.page_title
        : "MIS - Dental Implants Technology";
    },
    pageDescription() {
      return this.pageLayoutData &&
        this.pageLayoutData.meta &&
        this.pageLayoutData.meta.meta_description
        ? this.pageLayoutData.meta.meta_description
        : "MIS - Dental Implants Technology";
    },
    pageKeywords() {
      return this.pageLayoutData &&
        this.pageLayoutData.meta &&
        this.pageLayoutData.meta.meta_keywords
        ? this.pageLayoutData.meta.meta_keywords
        : "MIS, dental implants, c1, v3";
    }
  },
  mounted()
  {
    var vm=this;
    //setTimeout(() => {
      //vm.addDocumentEvents();
    //}, 1000);
  },
  created()  
  {            
      var vm = this;
      this.setPageReady(false);
      this.initScrollListener();
      this.loadData();
      this.setPageReady(true);
    },
    destroyed() {
      window.removeEventListener("scroll", this.scrollHandler);
    },
    methods: 
    {
      ...mapActions(["setMinisiteData","setMinisiteDic","xSetPlatform","initRouteByCid","setPageReady"]),
      findNodeByType(arr, typeName)
      {
        for (const item of arr) 
        {
          if (item.type === typeName) {return item;}
          const possibleResult = this.findNodeByType(item.children, typeName);
          if (possibleResult) {
            return possibleResult;
          }
        }
      },
      findNodeByTitle(arr, title)
      {
        for (const item of arr) {
          if (item.title === title) {return item;}
          const possibleResult = this.findNodeByTitle(item.children, title);
          if (possibleResult) {
            return possibleResult;
          }
        }
      },

      loadSiteData(fileName)
      {
        var vm = this;

        //LOAD CONTENTS FROM ADMIN
        vm.loadProductData();        

        //LOAD CONTENTS FROM JSON 
        //var APP_SITE_NAME = "lance";
        var APP_SITE_NAME = "seven";
        var apiURL = "content/"+APP_SITE_NAME+"/data/"+fileName;//e.g:"/site_data.json";
        fetch(apiURL, 
        {
            method: "GET",
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {"Content-Type": "application/json;charset=UTF-8",'Access-Control-Allow-Origin': '*'},
        })
        .then(function(response) { return response.json();})
        .then(function(response)
        {
            if(fileName=="site_data.json")
            {
              vm.minisite_data = response;
              vm.setMinisiteData(response);
              vm.loadSiteData("site_dictionary.json");
            }
            if(fileName=="site_dictionary.json")
            {
              vm.minisite_dictionary = response;
              vm.setMinisiteDic(response);
              vm.minisite_ready = true;              
            }
        }        
        );
      },      
      loadProductData()
      {
          //load the product page data from the admin 
          //clinical cases / publications / links sections
          //this.initRouteByPath(`HomeV3/${this.$route.params.locale || "global"}`);
          //page/3390
          //https://api.mis-implants.com/api/page/3390
          
          //TODO1:
          //FIND THE _cid BY THE PAGE PATH (CHECK PAGE.VUE) 
          var _cid = 3390; //seven         
          this.initRouteByCid(_cid); 
          //this.initRouteByCid(item.cid);

      },
      navToStart()
      {
          document.getElementsByClassName("siteSection")[0].scrollIntoView({ 
            behavior: 'smooth' 
          });
      },
      initScrollListener() 
      {
        window.addEventListener("scroll", this.scrollHandler, false);      
      },    
      scrollHandler() {
        this.checkSectionsView();
      },
      checkSectionsView()
      {
        var vm=this;
        var reveals = document.querySelectorAll(".siteSection");

        for (var i = 0; i < reveals.length; i++) 
        {
          var windowHeight = window.innerHeight;
          var elementTop = reveals[i].getBoundingClientRect().top;
          var elementVisible = 100;//350;
          if (elementTop < windowHeight - elementVisible && elementTop>0) 
          {
            if(vm.visibleSection != i)
            {
              vm.visibleSection = i;
              vm.onSectionVisible(i);
            }
          }
        }
      },
      onSectionVisible(domSectionIndex)
      {
          var vm=this;
          let sectionIndex = domSectionIndex;
          var sectionElement = document.querySelectorAll(".siteSection")[domSectionIndex];
          let sectionDataIndex = sectionIndex;
          if(sectionIndex>0){
            sectionDataIndex--;//!important because the dom 1st section is empty section
          }

          

          var secData =  this.minisite_data.SECTIONS[sectionDataIndex];

          var vid = document.getElementById("videoBgHero");

          //not sure if we will need this:
          //this.setVisibleSection(sectionIndex);//change the store value

          if(domSectionIndex>2){          
            vid.pause();//pause video when hero is hidden
            //when scrolling to section 2 (ImplantRange) or futher, by defult select the 3.75 platform
            setTimeout(() => {
              vm.xSetPlatform(1);  
            }, 1800);
          }else{
            vid.play();//resume video when hero is visible
          }
          //check when kit section is revealed


          console.log("...sectionDataIndex="+sectionDataIndex+" secData.section="+secData.section);
          if(secData.section=='benefits')
          {
            //alert("secData.section="+secData.section);

            //the scroller on benefits is hidden becuase it's stopping the site from scrolling the hero to the benefits
            //when revealing the 'benefits' section set timeout for 1 sec and show the benfits scroller
            //imgBnScroller1 add 'show' class after 1 sec
            setTimeout(() => {
              var imgBnScroller1 = document.getElementById("bnScrollerWrapper");
              imgBnScroller1.classList.add("show");//(display block)           
            }, 1100);
            setTimeout(() => {
              var imgBnScroller1 = document.getElementById("bnScrollerWrapper");
              imgBnScroller1.classList.add("showOpaq"); //remove opacity            
            }, 1300);
          }
          
          if(secData.section == 'surgical_kit')
          {
            var kitVideo = document.getElementById("kitVideo");
            kitVideo.play();//start kit video 
          }

          this.revealSectionChildrenElements(sectionElement);
      },

      // REAVEL CHILD ELEMENTS 
      revealSectionChildrenElements(parentElement) 
      {
        var vm=this;
        parentElement.classList.add("active");

        var reveals = parentElement.querySelectorAll(".reveal");
        for (var i = 0; i < reveals.length; i++){
            if(reveals[i].classList.contains("active")==false)
            {
              vm.onRevealingSection(reveals[i].id);
              reveals[i].classList.add("active");
            }
        }
      },
      onRevealingSection(sectionID)
      {
        if(sectionID=='hpSpeakers' || sectionID=='hpProgram'){
          //Add delay to enable this section
          //this is to avoid mouse colloision on circles animations
          setTimeout(() => {
            let sectionElement = document.getElementById(sectionID);
            sectionElement.classList.remove("disabledSection");
          }, 1500);
        }
      },      
        toggleLangMenu()
        {
          if(this.isLangOpen){
            this.isLangOpen = false;//close it
          }else{
            this.isLangOpen = true;//open lang
            this.isMenuOpen=false;//close main menu
          }
        },
        openMenu()
        {
          this.isMenuOpen=true;
          this.isLangOpen=false;
        },
        getLangByRoute()
        {
          let lc = this.$route.params.lang;
          if(lc == undefined){lc="en";}
          return lc;
        },
        loadData: function () 
        {
          let lc = this.getLangByRoute();                
          this.loadSiteData("site_data.json");
        }
    },
    watch: 
    { 
     '$route.params.lang': {        
        handler: function(lang) {          
          this.loadData();
        },
        deep: true,immediate: false
      }
    }   
  }
</script>
